import { SALESFORCE_ID, SALESFORCE_NAME, SALESFORCE_URL, SALESFORCE_SCRT2URL, SALESFORCE_ALLOWED_USER_TYPE_ID } from "@constants";
import { datadogLogs } from "@datadog/browser-logs";

/* eslint-disable camelcase */
let chatReady = false;
const CHAT_HIDE_DELAY = 200;

const showSalesforceChat = () => {
	const chat = document.getElementById("embedded-messaging");
	const userflow = document.getElementById("userflow-ui");

	if (chat) chat.style.display = "";
	if (userflow) userflow.style.display = "none";
};

const hideSalesforceChat = () => {
	const chat = document.getElementById("embedded-messaging");
	const userflow = document.getElementById("userflow-ui");

	if (chat) chat.style.display = "none";
	if (userflow) userflow.style.display = "";
};

const addEventListeners = () => {
	window.addEventListener("onEmbeddedMessagingWindowMaximized", () => {
		showSalesforceChat();
	});

	window.addEventListener("onEmbeddedMessagingWindowClosed", () => {
		setTimeout(hideSalesforceChat, CHAT_HIDE_DELAY);
	});

	window.addEventListener("onEmbeddedMessagingWindowMinimized", () => {
		hideSalesforceChat();
	});

	window.addEventListener("onEmbeddedMessagingReady", () => {
		chatReady = true;
		setTimeout(hideSalesforceChat, CHAT_HIDE_DELAY);
	});

	window.parent.addEventListener("message", event => {
		if (!event?.data?.event) return;

		switch (event.data.event) {
			case "iframeClicked": {
				if (chatReady && window.embeddedservice_bootstrap?.utilAPI?.launchChat) {
					window.embeddedservice_bootstrap.utilAPI.launchChat();
				}
				break;
			}

			case "clearChat": {
				const chatWidget = document.getElementById("embedded-messaging");

				if (chatWidget) chatWidget.remove();

				window.embeddedservice_bootstrap.userVerificationAPI.clearSession();

				break;
			}

			default: {
				datadogLogs.logger.info("Unhandled message event from Salesforce:", event.data.event);
				break;
			}
		}
	});
};

const isValidUserTypeId = (userTypeId) => {
	if (Number.isNaN(parseInt(userTypeId, 10))) {
		datadogLogs.logger.error("Invalid userTypeId provided:", userTypeId);
		return false;
	}

	return true;
};

const getAllowedUserTypeIds = () => {
	try {
		const parsed = JSON.parse(SALESFORCE_ALLOWED_USER_TYPE_ID);
		if (!Array.isArray(parsed)) {
			throw new Error("Parsed value is not an array");
		}
		return parsed.map(Number);
	} catch (err) {
		datadogLogs.logger.error("Error parsing SALESFORCE_ALLOWED_USER_TYPE_ID:", err.message);
		return [];
	}
};

const initSalesforce = (userTypeId) => {
	if (!isValidUserTypeId(userTypeId))
		return

	const userTypeIdNumber = Number(userTypeId);
	const allowedUserTypeIds = getAllowedUserTypeIds();

	if(!allowedUserTypeIds.includes(userTypeIdNumber))
		return;

	try {
		window.embeddedservice_bootstrap.settings.language = "en_US";

		window.embeddedservice_bootstrap.init(
			SALESFORCE_ID,
			SALESFORCE_NAME,
			SALESFORCE_URL,
			{
				scrt2URL: SALESFORCE_SCRT2URL,
			},
		);

		addEventListeners();
	} catch (err) {
		datadogLogs.logger.error("Error initializing Embedded Messaging:", err.message);
	}
}

export default {
	initSalesforce
};
